import React from "react";
import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";

//components
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/Footer/Footer";

//pages

import Home from "../pages/Home/Home";
import About from "../pages/AboutUs/About";
import Business from "../pages/Business/Business";
import Contact from "../pages/Contact/Contact";

const Router = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/business" element={<Business />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default Router;
